export const convertCentsToDollars = (cents: number) => {
  return cents / 100;
};

export const convertDollarsToCents = (dollars: number) => {
  return dollars * 100;
};
